/*
* @author 友人a丶
* @date 2022-07-11
*
* 系统设置
* */
import logo from '@/assets/image/logo.png'

export default {
    logo: logo, //系统logo
    title: "龙岛服务器", //标题
    index: '/index/server-info', //默认首页
    /*权限验证模式*/
    auth: {
        mode: 'token', //token、cookie
        token: 'X-Token' //token是需要填写认证头
    },
    layout: {
        showHeadermenu: false  //是否显示顶部菜单
    }
}